<template>
  <div class="not-select" style="letter-spacing: 0.5px;background:#fff">
    <!--    Head-->
    <div class="article_head">
      <div class="flex-center-center">
        <i class="el-icon-arrow-left" @click="back"></i>
        <div
          class="flex-center-center"
          @click="toMineNav(artData.createUserId)"
        >
          <div>
            <el-avatar
              v-if="artData.pic && artData.pic !== '/images/mine_deep.png'"
              :size="28"
              :src="artData.pic"
              style="border: 1px solid #eee;margin:0 6px"
            ></el-avatar>
            <el-avatar
              v-else
              :size="28"
              src="./../../../static/user_pic_default.png"
              style="border: 1px solid #eee;margin:0 6px"
            ></el-avatar>
          </div>
          <span
            style="letter-spacing: 0px;font-size: 13px;color:#000"
            v-if="artData.name"
            >{{ artData.name }}</span
          >
        </div>
      </div>
      <div class="flex-center-center">
        <div v-if="user.userId !== artData.createUserId">
          <el-button
            size="mini"
            plain
            :class="{ isFollow: !artData.isFollow }"
            style="color: #999;border: 1px solid #f2f2f2;font-size: 14px;padding: 6px 12px;"
            @click="attention"
            >{{ artData.isFollow ? "已关注" : "关注" }}</el-button
          >
        </div>
        &nbsp;&nbsp;&nbsp;
        <!--      <div v-else>-->
        <!--        <i class="el-icon-more" @click="opMain = true" style="transform: rotate(90deg)"></i>-->
        <!--      </div>-->
        <div>
          <i
            class="el-icon-more"
            @click="_share"
            style="transform: rotate(90deg);margin-right:10px;font-size: 16px;"
          ></i>
        </div>
      </div>
    </div>

    <!--    Content-->
    <div style="padding:42px 0 68px 0" v-if="!error">
      <div class="article_banners">
        <mt-swipe
          :auto="0"
          :style="{ height: mtHeight + 'px' }"
          v-if="fileList.length"
        >
          <mt-swipe-item v-for="(item, index) in fileList" :key="index">
            <div class="flex-center-center" style="background: #fff">
              <el-image
                @click="previewImg = item"
                :src="item"
                fit="contain"
              ></el-image>
            </div>
          </mt-swipe-item>
        </mt-swipe>
        <div
          v-if="!mtHeight"
          class="flex-center-center"
          style="height:250px;background: #f5f5f5;font-size: 14px"
        >
          <i class="el-icon-loading"></i>
          <span>加载中...</span>
        </div>
      </div>
      <div class="article_content">
        <div class="content-head">{{ artData.title }}</div>
        <div class="content-text" style="user-select: auto">
          <div v-html="replceBr(artData.content)" id="content"></div>
        </div>
        <div
          class="flex-between-center"
          v-if="artData.createTime"
          style="border-bottom: 1px solid #f3f3f3;padding: 15px 0;font-size: 12px;color:#999"
        >
          <div>
            <span>{{ artData.createTime | reactTime }}</span>
          </div>
          <div class="flex-center-center">
            <div @click="complaint = true" v-if="token">
              <i class="el-icon-warning-outline"></i>&nbsp;<span>举报</span>
            </div>
          </div>
        </div>
        <div class="flex-between-center" style="padding-top: 15px">
          <div
            class="flex-center-center"
            style="color: #5A5B5C;font-size: 14px;"
          >
            共{{ commentTotal(commentList) }}条评论
          </div>
          <el-button
            size="small"
            type="primary"
            style="font-size: 14px;padding: 6px 12px;"
            @click="addComment(null)"
            >发布评论</el-button
          >
        </div>
        <div v-if="!commentList.length">
          <div
            class="flex-center-center flex-column"
            style="height: 150px;font-size: 12px;color: #999"
          >
            <img src="../../assets/not-comment.png" style="width:100px" />
          </div>
        </div>
        <div class="comment-list" v-else>
          <div
            class="comment-item"
            v-for="(item, index) in commentList"
            style="border-bottom: 1px solid #f3f3f3;padding: 10px 0"
            :key="index"
          >
            <Comment
              :option="item"
              @TouchCom="addComment"
              @LongPress="comLong"
              @login="p_showLoginModal"
            ></Comment>
            <div
              v-for="(item2, index2) in (item.child || { records: [] }).records"
              style="margin-left: 36px;padding: 2px 0"
              v-if="!!item.open || !index2"
              :key="1000 + index2"
            >
              <Comment
                :option="item2"
                @TouchCom="addComment"
                @LongPress="comLong"
                @login="p_showLoginModal"
              ></Comment>
            </div>
            <div
              style="margin-left: 45px;padding: 2px 0;font-size: 12px;color: #679b31"
              v-if="(item.child || { records: [] }).records.length > 1"
              @click="$set(item, 'open', !item.open)"
            >
              {{ !item.open ? "展开" : "收起" }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--    Foot-->
    <div class="article_foot" v-if="!error">
      <el-input
        id="comInp"
        ref="commentInp"
        v-model="inpText"
        :placeholder="inpTag"
        prefix-icon="el-icon-edit"
        style="width: 100%;margin:0 3%"
        @focus="inpFocus"
        @blur="inpBlur"
        @keydown.13.native="submitComment"
      ></el-input>
      <div class="submitBtnGroup" v-if="showSubBtn">
        <el-button
          id="submitBtn"
          @click.stop="submitComment"
          @mousedown="showSubBtn = false"
          >发送</el-button
        >
      </div>
      <div class="flex-around-center" v-if="!showSubBtn">
        <img
          :src="artData.isLike ? agreeAct : agree"
          style="width:35%"
          @click="operation(1)"
        />
        <div style="min-width: 30px;">
          {{ artData.likeNum | reactNumber("点赞") }}
        </div>
      </div>
      <div class="flex-around-center" v-if="!showSubBtn">
        <img
          :src="artData.isCollect ? startAct : start"
          style="width:35%"
          @click="operation(2)"
        />
        <div style="min-width: 30px;">
          {{ artData.collectNum | reactNumber("收藏") }}
        </div>
      </div>
    </div>

    <div
      v-if="error"
      class="flex-center-center"
      :style="{
        width: window.innerWidth + 'px',
        height: window.innerHeight + 'px'
      }"
    >
      <img src="../../assets/removed.png" style="width: 120px" />
    </div>

    <!--    举报-->
    <el-drawer title=" " size="230" :visible.sync="complaint" direction="btt">
      <div class="drawer-content not-select">
        <div>举报</div>
        <div v-for="item in complaintList" @click="complainting(item)">
          {{ item }}
        </div>
        <div style="color: #409eff" @click="complaint = false">取消</div>
      </div>
    </el-drawer>

    <!--    底层抽屉-->
    <el-drawer
      title=" "
      size="230"
      :visible.sync="drawer"
      :show-close="false"
      direction="btt"
    >
      <div class="drawer-content not-select" v-if="longPress">
        <div
          v-if="longPress"
          style="height:auto;flex-wrap: wrap;font-weight: 500;font-size: 12px;color: #999;padding:15px 20px"
        >
          <span v-if="!longPress.imgsUrl">{{ longPress.userName }}：</span
          >{{ longPress.content }}
        </div>
        <div
          style="color: #409eff"
          @click="[addComment(longPress), (longPress = null)]"
        >
          回复
        </div>
        <div style="color: #409eff" @click="copy">复制</div>
        <div
          style="color: #f56c6c"
          @click="deleteComment"
          v-if="!longPress.imgsUrl && longPress.createUserId === user.userId"
        >
          删除
        </div>
        <!--        <div style="color: #409eff" @click="complaint = true">举报</div>-->
        <div style="color: #409eff" @click="longPress = null">取消</div>
      </div>
    </el-drawer>

    <PreviewImg
      :actImg="previewImg"
      :images="fileList"
      @close="previewImg = null"
    ></PreviewImg>

    <shareTo
      :show="shareDialog"
      @close="shareDialog = false"
      :toWb="() => shareToWb()"
      :reportMain="() => (complaint = true)"
      :deleteMain="() => deleteMain()"
      :isAuthor="user.userId === artData.createUserId"
    ></shareTo>

    <nav-header
      ref="navHeader"
      v-bind:loginModalFlag="p_loginModalFlag"
      v-bind:showOrNot="p_showOrNot"
      v-on:showLoginModal="p_showLoginModal"
      v-on:closeLoginModal="p_closeLoginModal"
    >
    </nav-header>
  </div>
</template>

<script>
import NavHeader from "@/components/Header";
import { getCookie, deepClone, Base64 } from "../../util/util";
import PreviewImg from "./previewImg";
import { MessageBox } from "mint-ui";
import Comment from "./comment";
import axios from "axios";
import shareTo from "./shareTo";

export default {
  name: "articleMain",
  components: {
    Comment,
    PreviewImg,
    shareTo,
    NavHeader
  },
  data() {
    return {
      error: false,
      p_loginModalFlag: false,
      p_showOrNot: "not",
      shareDialog: false,
      agree: require("../../assets/heart.png"),
      agreeAct: require("../../assets/heart-act.png"),
      start: require("../../assets/collection.png"),
      startAct: require("../../assets/collection-act.png"),
      cp: null, // 当前评论的parent
      mtHeight: 0,
      showSubBtn: false,
      inpTag: "说点什么...",
      inpText: "",
      longPress: null, // 长按的评论
      complaint: false, // 举报
      complaintList: [
        "违法违规",
        "侵权投诉",
        "色情暴力",
        "虚假、造谣",
        "广告",
        "其他"
      ], // 举报列表
      artData: {},
      fileList: [],
      commentList: [],
      previewImg: null,
      title: "",
      keywords: "",
      description: "",
      token: getCookie("jianyanwang_token")
    };
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        { vmid: "keywords", name: "keywords", content: this.keywords },
        { vmid: "description", name: "description", content: this.description }
      ]
    };
  },
  computed: {
    window() {
      return window;
    },
    user() {
      return this.$store.state.user || {};
    },
    drawer: {
      set() {
        this.$set(this.$data, "longPress", null);
      },
      get() {
        return !!this.longPress;
      }
    },
    replceBr() {
      return function(v) {
        if (v) {
          let c = v;
          return c.replace(/\n/g, "<br>");
        }
      };
    },
    commentTotal() {
      return function(com) {
        let com_lv1 = com.length;
        let com_lv2 = com.reduce((e, i) => {
          let items = i.child ? i.child.records : [];
          return [...e, ...items];
        }, []).length;
        return com_lv1 + com_lv2;
      };
    }
  },
  watch: {
    fileList(n) {
      if (n.length) {
        let img = new Image();
        img.src = n[0];
        img.onload = () => {
          let mtHeight = (window.innerWidth * img.height) / img.width;
          this.mtHeight =
            mtHeight > window.innerHeight
              ? window.innerHeight - 156
              : mtHeight < 250
              ? 250
              : mtHeight;
        };
      }
      // Promise.all(n.map(async e => {
      //   return await new Promise(a => {
      //     var img = new Image()
      //     img.src = e
      //     img.onload = () => {
      //       a(img.height / img.width)
      //     }
      //   })
      // })).then(data => {
      //   let size = Math.max.apply(null, data)
      //   let mtHeight = window.innerWidth * size
      //   this.mtHeight = mtHeight > window.innerHeight ? mtHeight - 156 : mtHeight < 250 ? 250 : mtHeight
      // })
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.bindContentLong();

      document.body.addEventListener(
        "touchmove",
        e => {
          let $inp = this.$refs.commentInp;
          if ($inp) {
            e.returnValue = !$inp.focused;
          }
        },
        { passive: false }
      );

      document.body.scrollTop = document.body.scrollHeight;

      window.scrollTo(0, 0);

      this.getData();
    });
  },
  methods: {
    bindContentLong() {
      let timer = 0;
      let dom = document.getElementById(`content`);

      if (dom) {
        // 长按事件
        dom.ontouchstart = e => {
          timer = setTimeout(() => {
            e.preventDefault();
            this.comLong(this.artData);
          }, 600);
        };
        dom.ontouchmove = () => {
          clearTimeout(timer);
          timer = 0;
        };
        dom.ontouchend = () => {
          clearTimeout(timer);
          if (timer === 0) {
            return false;
          }
        };
      }
    },
    back() {
      if (window.history.length <= 1) {
        this.$router.push({ name: "HomePageHealth" });
        return false;
      } else {
        this.$router.back();
      }
    },
    p_showLoginModal() {
      this.p_loginModalFlag = true;
    },
    p_closeLoginModal() {
      setTimeout(() => {
        this.p_loginModalFlag = false;
        if (getCookie("jianyanwang_token")) {
          this.getData();
        }
      });
    },
    comLong(op) {
      this.$refs.commentInp.blur();
      this.longPress = op;
    },
    addComment(e) {
      this.$nextTick(() => {
        this.$refs.commentInp.focus();
        document.getElementById("comInp").focus();
        setTimeout(() => {
          setTimeout(() => {
            this.showSubBtn = true;
          });
          if (e && !e.imgsUrl) {
            this.$set(this.$data, "inpTag", `回复 ${e.userName}：`);
            this.cp = e;
          } else {
            this.$set(this.$data, "inpTag", `说点什么...`);
            this.cp = null;
          }
        });
      });
    },
    shareToWb() {
      let { title, imgsUrl, status } = this.artData;
      if (status === 1) {
        try {
          var pic = JSON.parse(imgsUrl)[0];
        } catch (e) {
          var pic = "";
        }
        var url = `https://service.weibo.com/share/share.php?url=${encodeURIComponent(
          window.location.href +
            "&t=" +
            this.uuid() +
            "&uid=" +
            this.user.userId
        )}&title=${title}&appkey=${""}&pic=${pic}`;
        window.open(url, "newwindow");
      } else {
        this.Toast({
          message: "该作品正在审核中"
        });
      }
    },
    uuid: function() {
      function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      }
      return (
        S4() +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        S4() +
        S4()
      );
    },
    submitComment() {
      let inpText = this.inpText;
      let { id, createUserId } = this.artData;
      if (inpText) {
        axios
          .post(`/video/work/comment/save`, {
            wId: id,
            wUserId: createUserId,
            parentId: this.cp ? this.cp.id : 0,
            content: this.inpText
          })
          .then(({ data }) => {
            if (data.code === 0) {
              this.Toast("评论成功");
              this.inpText = "";
              this.cp = null;
              this.$refs.commentInp.blur();
              setTimeout(() => {
                this.getCommentList();
              }, 100);
            }
          });
      } else {
        this.Toast({
          message: "请输入要评论的内容"
        });
      }
    },
    deleteComment() {
      if (this.longPress) {
        let { id } = this.longPress;
        axios
          .post(`/video/work/comment/delete/${id}`)
          .then(({ data }) => {
            if (data.code === 0) {
              this.Toast({
                message: "删除评论成功"
              });
              this.$set(this.longPress, "content", null);
            }
          })
          .finally(() => {
            this.longPress = null;
          });
      }
    },
    copy() {
      if (this.longPress) {
        let { content } = this.longPress;
        var textareaEl = document.createElement("textarea");
        textareaEl.setAttribute("readonly", "readonly"); // 防止手机上弹出软键盘
        textareaEl.value = content;
        document.body.appendChild(textareaEl);
        textareaEl.select();
        var res = document.execCommand("copy");
        document.body.removeChild(textareaEl);
        if (res) {
          this.Toast({
            message: "复制成功"
          });
          this.longPress = null;
        }
        return res;
      }
    },
    complainting(type) {
      let { id } = this.artData;
      this.complaint = false;
      axios
        .post(`/video/report/save`, {
          type,
          reportWorkId: id
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.Toast("举报成功");
          }
        });
    },
    deleteMain() {
      let { id } = this.artData;
      this.shareDialog = false;
      MessageBox.confirm("确定删除作品？", "提示")
        .then(() => {
          axios.delete(`/video/work/${id}`).then(({ data }) => {
            if (data.code === 0) {
              this.Toast({
                message: "删除成功"
              });
              setTimeout(() => {
                this.$router.back();
              }, 1000);
            }
          });
        })
        .catch(() => {
          this.shareDialog = true;
        });
    },
    _share() {
      if (
        this.artData.status != 1 &&
        this.user.userId !== this.artData.createUserId
      ) {
        this.Toast("该作品尚正在审核中");
      } else if (this.error) {
        this.Toast("该作品已删除");
      } else if (getCookie("jianyanwang_token")) {
        this.shareDialog = true;
      } else {
        this.p_showLoginModal();
      }
    },
    inpBlur() {
      setTimeout(() => {
        // 开启页面滑动
        // this.cp = null
        // this.inpTag = '说点什么...'
        this.showSubBtn = false;
      });
    },
    inpFocus() {
      if (!getCookie("jianyanwang_token")) {
        this.p_showLoginModal();
        this.$refs.commentInp.blur();
      } else {
        this.showSubBtn = true;
        // 软键盘弹起后 页面将不能滑动
      }
    },
    getData() {
      const loading = this.$loading({
        lock: true,
        text: "拼命加载中...",
        spinner: "el-icon-loading"
      });
      let { id } = this.$route.query;
      axios
        .get(`/video/work`, {
          params: {
            id,
            userId: this.user.userId
          }
        })
        .then(({ data }) => {
          if (data.code === 0) {
            let { imgsUrl, delFlag } = data.result;
            this.$set(this.$data, "fileList", JSON.parse(imgsUrl) || []);
            this.$set(this.$data, "artData", {
              ...this.artData,
              ...data.result
            });
            // 修改metaInfo
            this.title = data.result.title;
            this.keywords = data.result.title;
            this.description = data.result.content;
            if (delFlag === -1) {
              // 该作品已删除
              this.error = true;
            } else {
              this.getCommentList();
              this.shareArt();
            }
          } else {
            console.error(data);
          }
        })
        .finally(() => {
          loading.close();
        });
    },
    shareArt() {
      // 通过分享链接打开, 统计分享数据
      let { t, uid } = this.$route.query;
      let { id, createUserId } = this.artData;
      if (this.$route.query.t) {
        let base64 = new Base64();
        let code = base64.encode(`3_${id}_${createUserId}_${t}_${uid}`);
        axios
          .post(`/video/work/operation/forward`, {
            keyCode: code
          })
          .then(({ data }) => {
            console.log(data);
          });
      }
    },
    getCommentList() {
      let { id } = this.artData;
      axios
        .get(`/video/work/comment/list`, {
          params: {
            limit: 9999,
            page: 1,
            wId: id,
            userId: this.user.userId
          }
        })
        .then(({ data }) => {
          setTimeout(() => {
            let { id, navType, cid } = this.$route.query;
            let oldCom = deepClone(this.commentList);
            this.$set(
              this.$data,
              "commentList",
              data.page.list.map(e => {
                return {
                  ...e,
                  open:
                    e.id == cid ||
                    (e.child || { records: [] }).records.find(
                      ee => ee.id == cid
                    )
                      ? true
                      : (
                          (oldCom || []).find(ee => ee.id === e.id) || {
                            open: null
                          }
                        ).open
                };
              })
            );
            setTimeout(() => {
              if (cid) {
                window.scrollTo(0, document.getElementById(cid).offsetTop - 72);
                this.$router.replace({
                  name: "ArticleMain",
                  query: { id, navType }
                });
              }
            });
          }, 100);
        });
    },
    operation(type) {
      if (!getCookie("jianyanwang_token")) {
        this.p_showLoginModal();
      } else {
        // type: 0:浏览 1:点赞 2:收藏
        let { id, createUserId, isLike, isCollect } = this.artData;
        let methods = (type === 1 ? isLike : isCollect) ? "delete" : "post";
        axios[methods](`/video/work/operation`, {
          ...(methods === "delete"
            ? {
                data: {
                  type: type,
                  wid: id
                }
              }
            : {
                type: type,
                wid: id,
                wuserId: createUserId
              })
        }).then(({ data }) => {
          if (data.code === 0) {
            this.Toast({ message: "操作成功" });
            let { isLike, likeNum, isCollect, collectNum } = data.result;
            if (type === 1) {
              this.$set(this.artData, "isLike", isLike);
              this.$set(this.artData, "likeNum", likeNum);
            } else if (type === 2) {
              this.$set(this.artData, "isCollect", isCollect);
              this.$set(this.artData, "collectNum", collectNum);
            }
          }
        });
      }
    },
    attention() {
      if (!getCookie("jianyanwang_token")) {
        this.p_showLoginModal();
      } else {
        let { createUserId } = this.artData;
        axios
          .post(`/video/user/follow/saveOrDelete/${createUserId}`)
          .then(({ data }) => {
            let { code, followStatus } = data;
            if (code === 0) {
              this.$set(this.artData, "isFollow", followStatus);
              this.Toast({
                message: !this.artData.isFollow ? "取消关注" : "关注成功"
              });
            }
          });
      }
    },
    toMineNav(createUserId) {
      this.$router.push({
        path:
          this.$store.state.user.userId === createUserId
            ? "/mineNav"
            : "/mineNavOther",
        query: {
          createUserId: createUserId
        }
      });
    }
  }
};
</script>

<style scoped>
.not-select {
  width: 60%;
  margin: 0 auto;
  box-sizing: border-box;
}
.flex-center-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.article_head {
  position: fixed;
  width: 60%;
  background: #fff;
  z-index: 2002;
  height: 42px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 8px;
  box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 1);
}
.article_head i {
  font-size: 21px;
  color: #000;
}
.article_content {
  padding: 15px;
}
.article_content > .content-head {
  color: #303030;
  font-size: 17px;
  font-weight: bold;
}
.article_content > .content-text {
  color: #5a5b5c;
  font-size: 16px;
  margin: 8px 0;
  line-height: 27px;
}
.article_foot {
  position: fixed;
  width: 60%;
  background: #fff;
  z-index: 2002;
  height: 62px;
  display: flex;
  bottom: 0px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 1);
}
.article_foot > div:first-child {
  padding: 0;
}
.article_foot > div {
  width: 20%;
  min-width: 70px;
  display: flex;
  align-items: center;
  color: #050505;
  font-size: 12px;
}
.article_foot span {
  margin: 5px;
}
.article_foot /deep/ .el-input__inner {
  border-width: 0px;
  background: #f5f5f5;
  height: 40px;
  border-radius: 50px;
  padding: auto 0;
}
.article_foot /deep/ .el-input__prefix {
  left: 10px;
  font-size: 15px;
}
.article_foot /deep/ .el-input--prefix .el-input__inner {
  padding-left: 36px;
  font-size: 13px;
  color: #5a5b5c;
}
* /deep/ .el-drawer__header {
  display: none;
}
* /deep/ .el-drawer {
  border-radius: 12px 12px 0 0;
}
* /deep/ .el-message-box {
  width: 75% !important;
}
.drawer-content > div {
  display: flex;
  align-items: center;
  justify-content: center;
  border-width: 0px 0px 1px 0px;
  border-color: #f3f3f3;
  border-style: solid;
  color: #5a5b5c;
  height: 46px;
  padding: 15px;
}
.drawer-content > div:first-child {
  display: flex !important;
  justify-content: center;
  align-items: center;
  height: 52px;
  font-weight: bold;
  font-size: 18px;
  color: #000;
}
.isFollow {
  color: #6b9731 !important;
  border-color: #6b9731 !important;
}
.submitBtnGroup {
  margin-left: 10px;
}
.submitBtnGroup > button {
  background: #6b9731;
  color: #fff;
  border-radius: 25px;
  height: 40px;
  letter-spacing: 2px;
  border-color: #6b9731;
}
* {
  touch-action: pan-y;
}
</style>



// WEBPACK FOOTER //
// src/pages/video/article_main.vue